import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    PriceLegend,
    PriceLegendItem,
    PriceLegendWrapper,
    InPlayRedirect,
    InPlayRedirectWrapper,
} from './PriceChangeLegend.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';

interface PropsType {
    isRace: boolean;
}

export const PriceChangeLegend = observer('PriceChangeLegend', ({ isRace }: PropsType): React.ReactElement | null => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const languagesState = LanguagesState.get(common);
    const environmentState = EnvironmentState.get(common);

    const getTranslation = languagesState.getTranslation;
    const theme = environmentState.emotionTheme;

    const PRICE_LEGEND_LIST = [
        {
            label: getTranslation('special-box.legend.selected', 'Selected'),
            type: 'betslip',
            color: theme.star.priceLegendList.statusFirst,
        },
        {
            label: getTranslation('special-box.legend.price-going-out', 'Price going out (Drifting)'),
            type: 'drifting',
            color: theme.star.priceLegendList.statusSecond,
        },
        {
            label: getTranslation('special-box.legend.price-coming-in', 'Price coming in (Shortening)'),
            type: 'shortening',
            color: theme.star.priceLegendList.statusThird,
        },
        {
            label: getTranslation('special-box.legend.suspended', 'Suspended'),
            type: 'suspended',
            color: theme.star.priceLegendList.statusFourth,
        },
    ];

    return (
        <PriceLegendWrapper variant={configState.componentVariants.sportsbookVariant}>
            <PriceLegend>
                {PRICE_LEGEND_LIST.map((listItem) => {
                    return (
                        <PriceLegendItem
                            itemColor={listItem.color}
                            key={listItem.type}
                        >
                            {listItem.label}
                        </PriceLegendItem>
                    );
                })}
            </PriceLegend>
            {configState.hasInPlayDelayInformation && isRace === false ? (
                <InPlayRedirectWrapper>
                    <I18n
                        langKey='events.in-play-delay-information'
                        defaultText='In-play information may be subject to delay.'
                    />
                    <InPlayRedirect to={{ account: 'static', static: 'in-play' }}>
                        <I18n
                            langKey='events.in-play-delay-information.button.more'
                            defaultText='More'
                        />
                    </InPlayRedirect>
                </InPlayRedirectWrapper>
            ) : null}
        </PriceLegendWrapper>
    );
});
